import { Toaster as Sonner } from 'sonner';
import { useTheme } from '@/shared/lib/theme';

/** Toaster com skin Glass, sincronizado com o tema. */
export function Toaster() {
  const { resolvedTheme } = useTheme();
  return (
    <Sonner
      theme={resolvedTheme}
      position="top-right"
      toastOptions={{
        classNames: {
          toast:
            'glass-elevated !rounded-xl !border-border/60 !text-foreground !shadow-glass-lg',
          description: '!text-muted-foreground',
          actionButton: '!bg-primary !text-primary-foreground',
          cancelButton: '!bg-secondary !text-secondary-foreground',
        },
      }}
    />
  );
}

export { toast } from 'sonner';
